import * as React from 'react';
import { st, classes } from './ToggleSwitch.st.css';
import { CoreToggleSwitch } from '../internal/WixUiCoreComponents/components/CoreToggleSwitch';
export class ToggleSwitch extends React.Component {
    static { this.displayName = 'ToggleSwitch'; }
    static { this.defaultProps = { ...CoreToggleSwitch.defaultProps }; }
    render() {
        const { checked, disabled, className, ...rest } = this.props;
        return (React.createElement(CoreToggleSwitch, { checked: checked, disabled: disabled, ...rest, className: st(classes.root, { checked, disabled }, className) }));
    }
}
//# sourceMappingURL=ToggleSwitch.js.map